import { Card, Stack, getSpacing } from "@compass/core";
import {
  AprRequestFilter,
  AprResource,
  AprUBResponse as AprResponseModel,
  AprSection,
} from "generated/openApi";
import "moment-timezone";
import { GenericAprSection } from "../AprTrio/AprTrioResponse/IIA/GenericAprSection";

export const AprUbResponse = (props: {
  filter: AprRequestFilter;
  resource: AprResource;
  response: AprResponseModel;
  aprSections: AprSection[];
  selectedSectionItemIds: number[];
}) => {
  const sectionResponse = props.response.projectIdentifiers;

  let title = `Year: ${props?.filter?.schoolYear}`;
  if (props?.filter?.programId) {
    const matchedProgram = props.resource.programs?.find(p => p.id == props.filter.programId);
    title += ` Program: ${matchedProgram?.name}`;
  }

  return (
    <Card>
      <Stack spacing="sm">
        <Stack pl={getSpacing("lg")} spacing="xl">
          <GenericAprSection title={title} response={sectionResponse || {}} />
        </Stack>
      </Stack>
    </Card>
  );
};
